export const styles = {
  imageContainer: {
    width: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}